module.exports = __webpack_public_path__ + "static/media/draft_icon.d01bb27b.svg";